import { gql } from '@apollo/client';

export const CallTransfer = gql`
    mutation callTransfer($callTransferActive: Boolean!, $callTransfers: [CallTransferInput!]! = [], $agentId: ID!) {
        callTransfer {
            updateOrCreate(callTransferActive: $callTransferActive, callTransfers: $callTransfers, agentId: $agentId) {
                ... on CallTransferSuccessType {
                    message
                    callTransfers {
                        id
                        phoneNumber
                        instructionBeforTransfer
                        beforTransferingMsg
                        callerIdStatus
                    }
                }

                ... on ErrorType {
                    message
                }
            }
        }
    }
`;

export const DeleteCallTransfer = gql`
    mutation callTransfer($callTransferId: ID!) {
        callTransfer {
            delete(callTransferId: $callTransferId) {
                ... on SuccessType {
                    message
                }

                ... on ErrorType {
                    message
                }
            }
        }
    }
`;
